// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"Projects_outerContainer__39dad","projectsRootContainer":"Projects_projectsRootContainer__jkARs"};